// extracted by mini-css-extract-plugin
export var bg = "bg-module--bg--3tvGp";
export var bgsvg = "bg-module--bgsvg--2J9q_";
export var bgdark = "bg-module--bgdark--3qAnm";
export var art = "bg-module--art--15_Ct";
export var finalclouds = "bg-module--finalclouds--1M6Yt";
export var finalcloudsbox = "bg-module--finalcloudsbox--3tffe";
export var rotate = "bg-module--rotate--u3WfK";
export var rotatetxt = "bg-module--rotatetxt--3BnBX";